export const LIST_HOLIDAY_REQUEST = 'LIST_HOLIDAY_REQUEST';
export const LIST_HOLIDAY_REQUEST_SUCCESS = 'LIST_HOLIDAY_REQUEST_SUCCESS';
export const LIST_HOLIDAY_REQUEST_FAILURE = 'LIST_HOLIDAY_REQUEST_FAILURE';

export const CLEAR_LIST_HOLIDAY = 'CLEAR_LIST_HOLIDAY';

export const NEW_HOLIDAY_REQUEST = 'NEW_HOLIDAY_REQUEST';
export const NEW_HOLIDAY_REQUEST_SUCCESS = 'NEW_HOLIDAY_REQUEST_SUCCESS';
export const NEW_HOLIDAY_REQUEST_FAILURE = 'NEW_HOLIDAY_REQUEST_FAILURE';

export const EDIT_HOLIDAY_REQUEST = 'EDIT_HOLIDAY_REQUEST';
export const EDIT_HOLIDAY_REQUEST_SUCCESS = 'EDIT_HOLIDAY_REQUEST_SUCCESS';
export const EDIT_HOLIDAY_REQUEST_FAILURE = 'EDIT_HOLIDAY_REQUEST_FAILURE';
export const SET_HOLIDAY_TO_EDIT = 'SET_HOLIDAY_TO_EDIT';

export const DELETE_HOLIDAY_REQUEST = 'DELETE_HOLIDAY_REQUEST';
export const DELETE_HOLIDAY_REQUEST_SUCCESS = 'DELETE_HOLIDAY_REQUEST_SUCCESS';
export const DELETE_HOLIDAY_REQUEST_FAILURE = 'DELETE_HOLIDAY_REQUEST_FAILURE';

export const CLEAR_HOLIDAY_BY_ID = 'CLEAR_HOLIDAY_BY_ID';

export const HOLIDAY_TYPE_LIST_REQUEST = 'HOLIDAY_TYPE_LIST_REQUEST';
export const HOLIDAY_TYPE_LIST_REQUEST_SUCCESS = 'HOLIDAY_TYPE_LIST_REQUEST_SUCCESS';
export const HOLIDAY_TYPE_LIST_REQUEST_FAILURE = 'HOLIDAY_TYPE_LIST_REQUEST_FAILURE';
export const CLEAR_HOLIDAY_TYPE_LIST = 'CLEAR_HOLIDAY_TYPE_LIST';